"use client"
/* */
class Item {
  id;
  data;
  collection;
  constructor(collection, id, data) {
    this.collection = collection;
    this.id = id;
    this.data = data;
  }
  static fromRow(collection, row) {
    return new Item(collection, row.id, row.original);
  }
}

export { Item };
//# sourceMappingURL=Item.mjs.map
